// removed by extract-text-webpack-plugin
module.exports = {"arrowDownWrapper":"_1SBSeETaf5R5JDqpExWrvw","fade_move_down":"_6kmEf2nG8iRJBTLakdcyb","arrowDown":"_3v2xz3LRL3bZDx4Ms2jG89"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/ArrowScroll/index.css
// module id = 248
// module chunks = 0